var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttentionIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4149 4.7886C33.6068 11.093 33.516 21.2232 27.2114 27.4151C20.9067 33.6069 10.7768 33.5158 4.58492 27.2114C-1.60699 20.907 -1.51578 10.7768 4.78859 4.58491C11.093 -1.60699 21.223 -1.51577 27.4149 4.7886Z",
    fill: "url(#paint0_linear_238_403)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0026 7.29491C12.961 6.67167 13.4302 6.13295 14.0569 6.07713C14.2577 6.05924 14.4565 6.04587 14.6532 6.03713C15.2114 6.01275 15.7384 6.00003 16.2355 6.00003C16.732 6.00003 17.2529 6.01275 17.7992 6.03713C18.0046 6.04646 18.2147 6.06109 18.4303 6.08088C19.0506 6.13783 19.5093 6.68011 19.468 7.29693L18.6842 19.0457C18.6471 19.598 18.2183 20.0473 17.6644 20.1084C17.5393 20.1222 17.4197 20.1338 17.3058 20.1432C16.929 20.175 16.5721 20.1903 16.2354 20.1903C15.8371 20.1903 15.3631 20.1607 14.8124 20.101C14.2561 20.0408 13.8233 19.5919 13.7864 19.0376L13.0026 7.29491ZM16.2354 22.2093C16.6207 22.2093 17.0104 22.2242 17.4051 22.2538C17.5049 22.2614 17.6064 22.2698 17.7094 22.2793C18.2656 22.3304 18.7075 22.77 18.7536 23.3229L18.7542 23.3322C18.7782 23.6226 18.7836 23.8994 18.771 24.1628C18.7584 24.4237 18.7267 24.6953 18.677 24.9777C18.6752 24.985 18.674 24.9923 18.6728 24.9996C18.5818 25.5089 18.1543 25.8923 17.6351 25.9372C17.5303 25.9463 17.4268 25.9544 17.3254 25.9615C16.9568 25.9871 16.5938 26 16.2354 26C15.8766 26 15.5134 25.9871 15.1455 25.9615C15.044 25.9544 14.9407 25.9462 14.8356 25.9372C14.3163 25.8923 13.8887 25.5088 13.7978 24.9992C13.7964 24.992 13.7952 24.9848 13.7939 24.9777C13.7436 24.6953 13.7123 24.4237 13.6997 24.1628C13.687 23.8994 13.6922 23.6226 13.7162 23.3322L13.7169 23.3234C13.7624 22.7702 14.2049 22.3304 14.7616 22.2793C14.8644 22.2699 14.9659 22.2614 15.0658 22.2538C15.4598 22.2242 15.8498 22.2093 16.2354 22.2093Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_238_403",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A78B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#846AB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239683,
    stopColor: "#8768B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#A159C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#C26792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE7F57"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionIcon);
export default __webpack_public_path__ + "static/media/attention-icon.8ba64c2847f972892cf132c3d9263181.svg";
export { ForwardRef as ReactComponent };